import React from 'react';

interface EstimateTypeBadgeProps {
  type: 'quick' | 'detailed';
}

const EstimateTypeBadge: React.FC<EstimateTypeBadgeProps> = ({ type }) => {
  const styles = {
    detailed: { background: '#EDE9FE', color: '#4C1D95', label: 'Détaillée' },
    quick:    { background: '#FEF3C7', color: '#78350F', label: 'Rapide' },
  };

  const { background, color, label } = styles[type];

  return (
    <span style={{
      fontSize: 10,
      fontWeight: 500,
      background,
      color,
      padding: '2px 7px',
      borderRadius: 99,
      whiteSpace: 'nowrap',
      flexShrink: 0,
      lineHeight: '16px',
    }}>
      {label}
    </span>
  );
};

export default EstimateTypeBadge;
